export { default as CollectionSolidIcon } from './CollectionSolidIcon';
